import type { MouseEvent } from 'react';

import type { ModalProps } from '@component/common/types';

export default function Modal({ title, children, wide, xwide, onClose }: ModalProps) {
  const handleOverlayClick = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="de-overlay" onClick={handleOverlayClick}>
      <div className={`de-modal${wide ? ' wide' : ''}${xwide ? ' xwide' : ''}`}>
        <div className="de-modal-hd">
          <h3>{title}</h3>
          <button type="button" className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="de-modal-body">{children}</div>
      </div>
    </div>
  );
}
